<template>
  <div
    class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup"
    v-show="open"
    :class="{ show: open }"
  >
    <div class="cstm-modal">
      <div class="header">
        <h3>Add Activity</h3>
        <button @click="closeModal" class="close-modal">&times;</button>
      </div>

      <div class="p-4 modal-content flex-col">
        <div class="flex flex-col mb-4 activity_type">
          <span class="mb-2">Activity Type</span>
          <div
            class="flex flex-wrap justify-between radio_card_holder width-20"
          >
            <v-select
              v-model="activityType"
              :options="typeOptions"
              label="title"
            >
              <template #option="{ title, icon }">
                <feather-icon
                  :icon="icon"
                  svgClasses="h-4 w-4"
                  class="align-middle mr-3"
                />
                <span> {{ title }}</span>
              </template>
            </v-select>
          </div>
        </div>

        <div class="flex flex-1 flex-col mb-4 activity_summary">
          <span class="mb-2">Activity Summary</span>
          <vs-textarea class="mb-0" v-model="activitySummary" />
          <span
            class="text-primary ml-auto mt-1 upload-file-button"
            @click="showUpload = !showUpload"
            >Upload Files</span
          >
        </div>

        <div class="flex flex-col mb-4 activity_files" v-if="showUpload">
          <span class="mb-2">Activity Files</span>
          <div class="cstm_vuefileagent_holder w-full">
            <file-upload-component
              @deletedIndex="deleteUploadedFile"
              @getFileId="getFileId"
              :file_repository_id="repository_id"
              :files_info="[]"
              :multiple="true"
            ></file-upload-component>
          </div>
        </div>

        <div class="flex flex-col mb-4 activity_result">
          <span class="mb-2">Activity Results</span>
          <div
            class="flex flex-wrap justify-between radio_card_holder width-33"
          >
            <vs-radio v-model="activityResult" vs-value="1">
              <div class="inline-flex items-center radio_card_inner_holder">
                <span class="material-icons-outlined">thumb_up</span>
                <span class="card_name">Interested</span>
              </div>
            </vs-radio>
            <vs-radio v-model="activityResult" vs-value="2">
              <div
                class="
                  inline-flex
                  items-center
                  radio_card_inner_holder
                  text-secondary
                "
              >
                <span class="material-icons-outlined text-secondary"
                  >help_outline</span
                >
                <span class="card_name">Not Decided</span>
              </div>
            </vs-radio>
            <vs-radio v-model="activityResult" vs-value="3">
              <div
                class="
                  inline-flex
                  items-center
                  radio_card_inner_holder
                  text-danger
                "
              >
                <span class="material-icons-outlined text-danger"
                  >thumb_down</span
                >
                <span class="card_name">Not Interested</span>
              </div>
            </vs-radio>
          </div>
        </div>

        <div class="flex flex-1 flex-col mb-4 activity_result_comment">
          <vs-checkbox v-model="showResultComments"
            >Comment on results</vs-checkbox
          >
          <vs-textarea
            v-if="showResultComments"
            class="mt-4"
            v-model="activityResultComments"
          />
        </div>

        <vs-divider />

        <div class="flex flex-col activity_follow_up mb-4">
          <div class="mb-2 flex">
            <span class="mr-auto">Follow Up</span>
            <vs-switch v-model="showFollowUp" />
          </div>
          <div v-if="showFollowUp">
            <div
              class="flex flex-wrap justify-between radio_card_holder width-20"
            >
              <v-select v-model="followUp" :options="typeOptions" label="title">
                <template #option="{ title, icon }">
                  <feather-icon
                    :icon="icon"
                    svgClasses="h-4 w-4"
                    class="align-middle mr-3"
                  />
                  <span> {{ title }}</span>
                </template>
              </v-select>
            </div>

            <div class="activity_reminder">
              <vs-checkbox class="mt-5 ml-0" v-model="reminder"
                >Set Reminder</vs-checkbox
              >
              <div v-if="reminder">
                <div class="flex flex-col mt-3">
                  <span>Reminder Note</span>
                  <vs-textarea class="mb-0" v-model="reminderNote" />
                </div>
                <div class="flex flex-col mt-3 width-20">
                  <span>Date and Time</span>
                  <flat-pickr
                    :config="{
                      altInput: true,
                      enableTime: true,
                      altFormat: 'j F, Y G:i K',
                      dateFormat: 'Y-m-d H:i:S'
                    }"
                    v-model="reminderDateTime"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-1 actions mt-10 justify-end">
          <vs-button type="border" @click="closeModal">Cancel</vs-button>
          <vs-button class="ml-5" @click="saveActivity">Save</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component"
import vSelect from "vue-select"

import FileUploadComponent from "../../classes/components/FileUploadComponent"
import { repository } from "@/mixins/repository.js"
import { createActivity } from "@/api/activityLog"

import "flatpickr/dist/flatpickr.css"

export default {
  name: "addActivityModal",
  mixins: [repository],
  props: ["open"],
  data () {
    return {
      activityType: null,
      activitySummary: "",
      activityResult: "",
      activityResultComments: "",
      followUp: null,
      reminder: false,
      reminderNote: "",
      reminderDateTime: null,
      uploadedFiles: [],
      customer_id: null,
      typeOptions: [
        { id: 'note', icon: 'FileIcon', title: 'Notes' },
        { id: 'email', icon: 'MailIcon', title: 'Email' },
        { id: 'call', icon: 'PhoneCallIcon', title: 'Call' },
        { id: 'sms', icon: 'MessageSquareIcon', title: 'Sms' },
        { id: 'chat', icon: 'MessageCircleIcon', title: 'Chat' },
      ],
      showResultComments: false,
      showFollowUp: false,
      showUpload: false,
    }
  },
  components: {
    FileUploadComponent,
    flatPickr,
    'v-select': vSelect,
  },
  created () {
    this.customer_id = localStorage.getItem("customer_id")
    this.getRepositoryId(1)
  },
  methods: {
    closeModal () {
      this.activityType = null
      this.activitySummary = ""
      this.activityResult = ""
      this.activityResultComments = ""
      this.followUp = null
      this.reminder = false
      this.reminderNote = ""
      this.reminderDateTime = null
      this.uploadedFiles = []

      this.$emit("closeModal", false)
    },
    getFileId (file_id) {
      this.uploadedFiles.push(file_id)
    },
    deleteUploadedFile (index) {
      this.uploadedFiles.splice(index, 1)
    },
    async saveActivity () {
      const payload = {
        customer_id: this.customer_id,
        platform_module_id: 1,
        entity_id: this.$route.params.leadId,
        activity_type: this.activityType.id,
        description: this.activitySummary,
        activity_result_id: this.activityResult,
        comment: this.activityResultComments,
        next_follow_up_activity_type: this.followUp && this.followUp.id,
        has_reminder: this.reminder,
        reminder_note: this.reminderNote,
        reminder_datetime: this.reminderDateTime,
        file_ids: this.uploadedFiles,
      }

      try {
        const response = await createActivity(payload)

        if (response.status === 202) {
          this.$emit("activityAdded", response.data.data.activity)

          this.showSuccessMessage("Success", "New Activity Created", "success")
          this.closeModal()
        }
      } catch (e) {
        this.showSuccessMessage("Error", "Validation is required", "danger")
        this.closeModal()
      }
    },
  },
};
</script>

<style lang="scss">
.text-secondary {
  color: rgb(198, 198, 198) !important;
}

.upload-file-button {
  cursor: pointer;
}
</style>
